import React, { useState } from 'react';
import { TextField, Box } from '@mui/material';
import ActionDialog from 'common/components/ActionDialog';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	onSave: (newColumnName: string) => void;
	onClose: () => void;
}

const AddColumnDialog = (props: Props) => {
	const { t } = useTranslation();
	const [newColumnName, setNewColumnName] = useState('');

	const handleSave = async () => {
		props.onSave(newColumnName);
	};

	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNewColumnName(e.target.value);
	};

	return (
		<ActionDialog
			title={t('product.variantsTable.columnsAddTitle', 'Create a new variant option')}
			headerVariant="contained"
			btnActions={{
				primary: {
					text: t('common:actions.save'),
					disabled: !newColumnName.length,
					onClick: handleSave,
				},
				secondary: {
					text: t('common:actions.cancel'),
					onClick: props.onClose,
				},
			}}
			onClose={props.onClose}
		>
			<Box mt={1}>
				<TextField
					label={t('product.nameOfPropertyPrompt', 'Option name')}
					variant="outlined"
					value={newColumnName}
					onChange={handleNameChange}
				/>
			</Box>
		</ActionDialog>
	);
};

export default AddColumnDialog;
